export const theme = {
  addressTextTransform: 'uppercase',
  directionsLinkStyledColor: Styles.color.grey.one,
};
